import { render, staticRenderFns } from "./TakipHarcYokTaslak.vue?vue&type=template&id=0d5ea33c"
import script from "./TakipHarcYokTaslak.vue?vue&type=script&lang=ts"
export * from "./TakipHarcYokTaslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports